import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Button, Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import { IconMail, IconPhone } from '../Icon';

const menu = (
  <Menu
    items={[
      { key: '1', label: 'InfoTRAC' },
      { key: '2', label: 'InfoPublisher' },
    ]}
  />
);

export default function FooterContent(): React.ReactNode | null {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.info}>
          <h2>Still have questions?</h2>
          <div className={styles.item}>
            <IconPhone />
            <div>
              <h4>Talk to our team</h4>
              <a href="tel:18662783216">1.866.278.3216</a>
            </div>
          </div>
          <div className={styles.item}>
            <IconMail />
            <div>
              <h4>Email us</h4>
              <a href="mailto:support@mail.com">support@mail.com</a>
            </div>
          </div>
        </div>
        <div>
          <img src="/media/footerImg.png" alt="" />
        </div>
      </div>
      <div className={styles.copyRights}>
        <div>
          <NavLink to="/" className="logo">
            <img src="/logo-default.svg" alt="" />
            <span style={{ color: '#1F3847', borderLeftColor: '#1F3847AD' }}>Help portal</span>
          </NavLink>
        </div>
        <div className={styles.menuRight}>
          <span>©2025 InfoIMAGE</span>
        </div>
      </div>
    </div>
  );
}
